<div id="overview" class="collapse show" data-parent="#menu-content">

  <div class="position-relative">
    <app-block-image-recap [iter]="iter" [lastUpdate]="lastUpdate" [state]="state"></app-block-image-recap>
  
    <ngb-carousel *ngIf="citiesImages && citiesImages.length > 0" #carousel [interval]="10000">
      <ng-template ngbSlide *ngFor="let img of citiesImages">
        <div class="picsum-img-wrapper">
          <img [src]="urlCitiesImages.concat(img)" [alt]="img">
        </div>
      </ng-template>
    </ngb-carousel>
  </div>

  <app-recap [days]="days" [serviceIcons]="serviceIcons" [version]="version" [noImageUrl]="noImageUrl"
    [defaultImages]="defaultImages"></app-recap>
</div>
